module.exports = __webpack_public_path__ + "json/callout-icons.json?a311fbd516a0acc0dee2f798a66f1789";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/callout-icons/callout-icons.json
// module id = 1732
// module chunks = 3